import { Appointment } from "@elixir/types";
import useArchiveAppointment from "../../../../apis/tryst/delete-archive-appointment";
import { ReactComponent as TrashRegularIcon } from "../../../../assets/icons/font-awesome/trash-regular.svg";
import { ChipWithTooltip } from "ui";

const ArchiveAppointment = ({
  apt,
  className = "",
  type,
}: {
  apt: Appointment;
  className?: string;
  type?: "primary" | "secondary";
}) => {
  const { mutateAsync: postArchiveAppointment } = useArchiveAppointment();

  return (
    <ChipWithTooltip
      onClick={() => {
        postArchiveAppointment({ appointment: apt });
      }}
      className={`h-32 flex-1 ${className}`}
      icon={<TrashRegularIcon className="dr-min-w-14 dr-h-14" />}
      title="Archive"
      tooltipText="Archive Appointment"
      type={type}
    />
  );
};

export default ArchiveAppointment;
